import React, { useEffect } from 'react';
import Home from './Home';

const Global360ChildPage = () => {
  useEffect(() => {
    // Defer until the page is mounted, then smooth-scroll to the section
    const t = setTimeout(() => {
      const el = document.getElementById('global-360-child');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 250);
    return () => clearTimeout(t);
  }, []);

  return <Home />;
};

export default Global360ChildPage;
